import Switch from './Switch'

import './style.scss'

export { Switch }
export default Switch
